import has from 'lodash/has';
import {
  LOADING_COMPLETED_COURSES,
  LOAD_COMPLETED_COURSES,
  ADD_COMPLETED_COURSE,
  LOADING_COMPLETED_COURSE_TOPICS,
  LOAD_COMPLETED_COURSE_TOPICS,
  ADD_COMPLETED_COURSE_TOPIC,
  LOADING_COMPLETED_TOPICS,
  LOAD_COMPLETED_TOPICS
} from './courses.types';

export const initialState = {
  completed: {},
  completedCourseTopics: {},
  loading: false,
  loaded: false,
  loadingCourseTopics: false,
  loadedCourseTopics: false
};

export default function reducer(state = initialState, { type, payload }) {
  switch (type) {
    case LOADING_COMPLETED_COURSES: {
      return {
        ...state,
        loading: true,
        loaded: false
      };
    }

    case LOAD_COMPLETED_COURSES: {
      const { completed } = payload;

      return {
        ...state,
        loading: false,
        loaded: true,
        completed: {
          ...completed
        }
      };
    }

    case ADD_COMPLETED_COURSE: {
      const { courseData } = payload;
      const { completed } = state;

      if (!courseData) {
        return state;
      }

      const { course_id } = courseData;
      completed[course_id] = courseData;

      return {
        ...state,
        completed: {
          ...completed
        }
      };
    }

    case LOADING_COMPLETED_COURSE_TOPICS: {
      return {
        ...state,
        loadingCourseTopics: true,
        loadedCourseTopics: false
      };
    }

    case LOAD_COMPLETED_COURSE_TOPICS: {
      const { completedTopicsForCourse, courseId } = payload;

      const { completedCourseTopics } = state;

      completedCourseTopics[courseId] = completedTopicsForCourse;

      return {
        ...state,
        loadingCourseTopics: false,
        loadedCourseTopics: true,
        completedCourseTopics: {
          ...completedCourseTopics
        }
      };
    }

    case ADD_COMPLETED_COURSE_TOPIC: {
      const { topicData, courseId } = payload;
      const { completedCourseTopics } = state;

      if (!topicData) {
        return state;
      }

      if (!has(completedCourseTopics, courseId)) {
        completedCourseTopics[courseId] = {};
      }

      completedCourseTopics[courseId][topicData?.topicid] = topicData;

      return {
        ...state,
        completedCourseTopics: {
          ...completedCourseTopics
        }
      };
    }

    case LOADING_COMPLETED_TOPICS: {
      return {
        ...state,
        loadingCourseTopics: true,
        loadedCourseTopics: false
      };
    }

    case LOAD_COMPLETED_TOPICS: {
      const { completedCourseTopics } = payload;

      return {
        ...state,
        loadingCourseTopics: false,
        loadedCourseTopics: true,
        completedCourseTopics: {
          ...completedCourseTopics
        }
      };
    }

    default:
      return state;
  }
}
